import { formatDateStr } from "src/utils/DateUtil";
import { HttpMethod } from "../types/HttpMethod";

const scheduleapiUrl = `${process.env.REACT_APP_BASE_URL}/rs/automation/schedule/job`;

export const getScheduledJobs = (auth: string, filterdata: any) => {
  const url = `${scheduleapiUrl}/getScheduleJobs`;
  const filterKeys = [
    "userSpecificScheduleJobId",
    "jobType",
    "scheduleJobStartDateTime",
    "scheduleJobEndDate",
    "countryCode",
    "status",
    "reportUser",
    "productCode",
    "clientCode",
  ];
  const data = filterKeys.reduce((key: any, value: any) => {
    if (filterdata[value]) {
      if (
        value === "scheduleJobStartDateTime" ||
        value === "scheduleJobEndDate"
      ) {
        key[value] = [
          formatDateStr(
            new Date(filterdata[value]),
            "YYYY-MM-DD HH:mm:ss",
            false
          ),
        ];
      } else {
        key[value] = [filterdata[value]];
      }
    }
    return key;
  }, {});
  return fetch(url, {
    method: HttpMethod.Post,
    headers: { Authorization: auth, "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
};
export const update = (
  auth: string,
  formData: FormData,
  productCode: string,
  clientCode: string
) => {
  const url = `${scheduleapiUrl}/${productCode}/update?clientCode=${clientCode}`;
  return fetch(url, {
    method: HttpMethod.Post,
    headers: {
      Authorization: auth,
    },
    body: formData,
  });
};

export const schedule = (
  auth: string,
  formData: FormData,
  productCode: string,
  clientCode: string
) => {
  const url = `${scheduleapiUrl}/${productCode}/create?clientCode=${clientCode}`;
  return fetch(url, {
    method: HttpMethod.Post,
    headers: {
      Authorization: auth,
    },
    body: formData,
  });
};

export const pause = (auth: string, formData: FormData) => {
  const url = `${scheduleapiUrl}/pause`;
  return fetch(url, {
    method: HttpMethod.Post,
    headers: {
      Authorization: auth,
    },
    body: formData,
  });
};

export const resume = (auth: string, formData: FormData) => {
  const url = `${scheduleapiUrl}/resume`;
  return fetch(url, {
    method: HttpMethod.Post,
    headers: {
      Authorization: auth,
    },
    body: formData,
  });
};

export const deleteJob = (auth: string, formData: FormData) => {
  const url = `${scheduleapiUrl}/delete`;
  return fetch(url, {
    method: HttpMethod.Post,
    headers: {
      Authorization: auth,
    },
    body: formData,
  });
};
